import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessLayout } from "../AccessLayout";
import { AccessEntities } from "../AccessEntities";
import { AccessProps } from "../AccessProps";
import PermissionPoliciesRolesTables from "../components/PermissionPoliciesRolesTables";

export interface OutgoingPermissionListPageProps extends NSARouterMakerResult, AccessProps { }

function OutgoingPermissionListPage(props: OutgoingPermissionListPageProps)
{
	return (
		<AccessLayout {...props}
			action={{
				title: "",
				description: "A list of permissions you've granted to other users for your account, helping you track them for privacy and security.",
				menus: {}
			}}
			pages={{
				entity: AccessEntities.outgoingPermission(props),
				list: {
					ui: {
						getChildrenAfter: (id) => id
							? <PermissionPoliciesRolesTables
								{...props}
								id={id}
								get={props.servers.access.permission.GetOutgoing}
							/>
							: <></>
					}
				}
			}}
		>
			<></>
		</AccessLayout>
	);
}

export default OutgoingPermissionListPage;